module.exports = __webpack_public_path__ + "static/media/nav-logo.e75f0850.webp";